

const timestampToDateString = (timestamp) => {
    const date = new Date(timestamp * 1000);
    const monthString = date.getMonth() < 10 ? `0${date.getMonth()}` : `${date.getMonth()}`
    const dayString = date.getDate() < 10 ? `0${date.getDate()}` : `${date.getDate()}`
    const dateString = `${date.getFullYear()}-${monthString}-${dayString}`;

    return dateString;
}

const timestampToTimeString = (timestamp) => {
    const date = new Date(timestamp * 1000);
    const hoursString = date.getHours() < 10 ? `0${date.getHours()}` : `${date.getHours()}`
    const minutesString = date.getMinutes() < 10 ? `0${date.getMinutes()}` : `${date.getMinutes()}`
    const secondsString = date.getSeconds() < 10 ? `0${date.getSeconds()}` : `${date.getSeconds()}`
    const timeString = `${hoursString}:${minutesString}:${secondsString}`;

    return timeString;
}

export { timestampToDateString, timestampToTimeString };